class RAMQPatient {
    public IndividualID: string;
    public FirstName: string;
    public LastName: string;
    public DDN: Date;
    public DDN_string: string;
    public NAM: string;
    public Sexe: string;
    public Langue: string;
    public FileNumber: string;
    public InscriptionVille: string;
    public InscriptionRue: string;
    public InscriptionCodePostal: string;
}

export { RAMQPatient };
